import { createSlice } from '@reduxjs/toolkit'
import { createActions } from '@helper'
import * as actions from '../action'

const initialState = {
    goodsBasicAttrDTO: {}, // 商品基本属性
    attrExt: [], // 特征属性
    customExt: [], // 定制属性
    skuList: [], // sku列表
    sizeGuide: [], // 尺码推荐表
    sizeTable: [], // 尺码表
    url: '' // 商品图片地址
}

const reducers = createActions({
    getRobotGoodsDetailAction: {
        success: (state, action) => {
            const {
                goodsBasicAttrDTO={}, 
                attrExt=[], 
                customExt=[], 
                skuList=[], 
                sizeGuide={}, 
                sizeTable={},
                url
            } = action.payload || {}

            return { 
                ...state,
                goodsBasicAttrDTO: typeof goodsBasicAttrDTO === 'object' ? goodsBasicAttrDTO : {},
                attrExt: Array.isArray(attrExt) ? attrExt : [],
                customExt: Array.isArray(customExt) ? customExt : [],
                skuList: Array.isArray(skuList) ? skuList : [],
                sizeGuide: sizeGuide ? [sizeGuide] : [],
                sizeTable: sizeTable ? [sizeTable] : [],
                url
            }
        }
    },
    toggleCustomExt: (state, action) => {
        const { obj, index } = action.payload
        if (typeof index === 'number' && index > -1 && index < state.customExt.length) {
            // 如果传了合法的 index，则删除该位置
            const updatedCustomExt = [...state.customExt]
            updatedCustomExt.splice(index, 1)
            return {
                ...state,
                customExt: updatedCustomExt
            }
        }
        // 否则添加对象
        const updatedCustomExt = [...state.customExt]
        if (obj && obj.id) {
            updatedCustomExt[Number(obj.id)] = obj
            delete updatedCustomExt[Number(obj.id)].id
        } else {
            updatedCustomExt.push(obj)
        }
        return {
            ...state,
            customExt: updatedCustomExt
        }
    }
}, actions)

const robotGoodsDetailSlice = createSlice({
    name: 'robotGoodsDetail',
    initialState,
    ...reducers
})

export const {toggleCustomExt} = robotGoodsDetailSlice.actions

export default robotGoodsDetailSlice
